import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MemberDto } from '../Manipulate/MemberDto';
import { NotificationDto } from '../Manipulate/Notification';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  // private apiUrl = 'http://localhost:5000/api/notification'; // Substitua pela URL correta
  private apiUrl = environment.apiUrl +'/notification';

  constructor(private http: HttpClient) { }
  list(): Observable<NotificationDto[]> {
    return this.http.get<NotificationDto[]>(this.apiUrl);
  }
  register(){
    return this.http.post(this.apiUrl,'');
  }
    delete(id: string): Observable<any> {
        return this.http.delete(`${this.apiUrl}/${id}`);
    }
}
